import React, { useState, useEffect } from 'react'
import { FlexboxGrid, Panel, Row } from 'rsuite'
import PanalLoadingTemplate from '../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import SearchWidget from './SearchWidget'
import StatusWidget from './StatusWidget'
import DashboradToggle from './DashboradToggle'
import HeaderConfig from './HeaderConfig'
import { getUpDownStremWidget, searchUpDownStremWidget } from '../../redux/actions/dashboard'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { useForm } from 'react-hook-form'

export default function UpDownStreamWidget({
  dashBoardName,
  config,
  configResult,
  onSettingChange = () => {},
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [datas, setDatas] = useState([])
  const [settingHeader, setSettingHeader] = useState()

  useEffect(() => {
    if (config) {
      setSettingHeader(
        dashBoardName == 'coodinatorSummary' ? 'แบบแสดงรายละเอียด' : 'แบบไม่แสดงรายละเอียด'
      )
      setSchema(settingSchema)
      setDatas(settingSchema.datas)
    } else {
      handelGetSchema()
    }
  }, [])

  const handelGetSchema = async () => {
    setIsLoading(true)

    sessionStorage.removeItem('up-down-strem-req')
    sessionStorage.removeItem('up-down-strem-key')
    sessionStorage.removeItem('up-down-strem-master-key')
    sessionStorage.removeItem('up-down-strem-status')

    try {
      const response = await getUpDownStremWidget()

      setSchema(response)

      sessionStorage.setItem(
        'up-down-strem-req',
        JSON.stringify({
          selfProject:
            response?.searchForm?.selfProject?.value == undefined
              ? true
              : response?.searchForm?.selfProject?.value,
        })
      )

      setDatas(response?.datas || [])
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const handelSearch = async (request) => {
    setIsSearching(true)
    try {
      sessionStorage.setItem('up-down-strem-req', JSON.stringify(request))

      const response = await searchUpDownStremWidget(request)

      setDatas(response)
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsSearching(false)
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <>
      {config && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={config.key}
          checked={configResult?.find((e) => e.key == config.key)?.show}
          style={{ marginTop: 20, marginBottom: -10 }}
        />
      )}
      <Panel
        //header={<HeaderConfig header={schema.header} config={config} onChange={onSettingChange} />}
        header={settingHeader || schema.header}
        bordered
        shaded
        collapsible
        defaultExpanded
        style={{ marginTop: 10, marginBottom: 10 }}
      >
        {!config && schema.searchForm && (
          <Row style={{ marginTop: -10 }}>
            <SearchWidget
              // userType={userType}
              schema={schema.searchForm}
              shaded={false}
              bordered={true}
              hideHeader={true}
              onSettingChange={onSettingChange}
              onSearch={handelSearch}
              onCancel={handelGetSchema}
              isLoading={isSearching}
            />
          </Row>
        )}

        {datas?.map((item) => (
          <>
            {config?.subConfig && (
              <DashboradToggle
                onChange={onSettingChange}
                // dashboradName={
                //   config?.subConfig?.find((e) => e.key == `${config.key}_${item.key}`)?.key
                // }
                // checked={config?.subConfig?.find((e) => e.key == `${config.key}_${item.key}`)?.show}
                dashboradName={config?.subConfig?.find((e) => e.key == item.key)?.key}
                checked={configResult?.find((e) => e.key == item.key)?.show}
                style={{ marginTop: 20, marginBottom: -10 }}
              />
            )}
            <Panel
              // header={
              //   <HeaderConfig header={item.header} config={config} onChange={onSettingChange} />
              // }
              header={item.header}
              bordered
              collapsible
              defaultExpanded
              style={{ marginBottom: 10 }}
            >
              {/* <Row style={{ marginTop: -30 }}> */}
              <FlexboxGrid style={{ marginTop: -30 }}>
                <StatusWidget
                  datas={item.datas || []}
                  showEnd={false}
                  showLine={item.key != 'OTH'}
                  dashBoardName={dashBoardName}
                  masterConfigKey={config?.key}
                  config={config?.subConfig}
                  configResult={configResult}
                  onSettingChange={onSettingChange}
                />
              </FlexboxGrid>
              {/* </Row> */}
            </Panel>
          </>
        ))}
      </Panel>
    </>
  )
}
const settingSchema = {
  header: 'ค้นหา',
  datas: [
    {
      header: 'Up Stream (จำนวนโครงการ)',
      bgColor: '#fca7a1',
      key: 'UP',
      datas: [
        {
          key: 'UP1',
          name: 'คัดกรอง',
          percent: '2.59%',
          count: 'N',
          countColor: '#7dc5e9',
          //warning: true,
          icon: 'spinner',
          iconColor: '#ffe0aa',
          details: [
            { name: 'คัดกรองขั้นต้น ', count: 'N' },
            { name: 'คัดกรอง', count: 'N' },
            { name: 'ส่งกลับภาคีแก้ไข ', count: 'N' },
          ],
        },
        {
          key: 'UP2',
          name: 'กลั่นกรอง',
          percent: '28.21%',
          count: 'N',
          countColor: '#7dc5e9',
          icon: 'filter',
          iconColor: '#fdcd9d',
          details: [
            { name: 'กลั่นกรอง ', count: 'N' },
            { name: 'ส่งกลับให้ผู้รับทุนแก้ไข', count: 'N' },
            { name: 'ศูนย์สัญญาตรวจสอบ', count: 'N' },
          ],
        },
        {
          key: 'UP3',
          name: 'พิจารณาอนุมัติ',
          percent: '1.54%',
          count: 'N',
          countColor: '#7dc5e9',
          icon: 'check-circle',
          iconColor: '#52b7ae',
          details: [
            { name: 'เสนออนุมัติ', count: 'N' },
            { name: 'อนุมัติขั้นต้น/ให้ความเห็น', count: 'N' },
            { name: 'ผู้มีอำนาจพิจารณา', count: 'N' },
          ],
        },
        {
          key: 'UP4',
          name: 'ทำสัญญาโครงการ',
          percent: '7.69%',
          count: 'N',
          countColor: '#7dc5e9',
          icon: 'character-authorize',
          iconColor: '#f4dcde',
          details: [
            { name: 'ทำสัญญา', count: 'N' },
            { name: 'ขอเอกสารเพิ่มเติม', count: 'N' },
            { name: 'ลงนามในสัญญา (แบบกระดาษ)', count: 'N' },
            { name: 'ผอ. ให้ความเห็นก่อนส่งลงนาม (e-Sig)', count: 'N' },
            { name: 'ผอ. ลงนาม (e-Sig)', count: 'N' },
            { name: 'ผู้มีอำนาจ(สสส.) ลงนาม (e-Sig)', count: 'N' },
            { name: 'ผู้รับทุนลงนาม (e-Sig)', count: 'N' },
            { name: 'ติดอากรและแนบบบัญชีโครงการ', count: 'N' },
            { name: 'ศูนย์สัญญาตรวจสอบ', count: 'N' },
          ],
        },
      ],
    },
    {
      header: 'Down Stream (จำนวนโครงการ)',
      bgColor: '#a7f2b1',
      key: 'DOWN',
      datas: [
        {
          key: 'DOWN1',
          name: 'การรายงานความก้าวหน้าโครงการ',
          percent: '7.69%',
          countColor: '#3f987f',
          count: 'N',
          icon: 'sliders',
          iconColor: '#ffa3ae',
          warning: true,
          details: [
            { name: 'ก่อนถึงกำหนด', count: 'N' },
            { name: 'เลยกำหนด', count: 'N', warning: true },
          ],
        },
        {
          key: 'DOWN2',
          name: 'รอเบิกเงินงวด',
          percent: '1.54%',
          count: 'N',
          countColor: '#3f987f',
          icon: 'money',
          iconColor: '#fbdf50',
          details: [
            { name: 'สำนักพิจารณาเอกสารขอเบิก', count: 'N' },
            { name: 'ผู้มีอำนาจพิจารณาคำขอเบิกเงิน', count: 'N' },
          ],
        },
        {
          key: 'DOWN3',
          name: 'จ่ายเงินโครงการ',
          percent: '5.13%',
          countColor: '#3f987f',
          count: 'N',
          icon: 'th-large',
          iconColor: '#e44d63',
          // warning: true,
          details: [
            { name: 'ฝ่ายบัญชีและการเงินตรวจสอบเอกสารประกอบการเบิก', count: 'N' },
            { name: 'ธนาคารโอนเงิน', count: 'N' },
          ],
        },
        {
          key: 'DOWN4',
          name: 'ขอปิด/ขอยุติ',
          percent: '3.85%',
          count: 'N',
          countColor: '#3f987f',
          iconColor: '#f9cdd1',
          icon: 'exit',
          details: [
            { name: 'สรุปผลการดำเนินการโครงการ', count: 'N' },
            { name: 'สำนักพิจารณาเอกสารขอปิดโครงการ ', count: 'N' },
            { name: 'สำนักจัดทำเอกสารประกอบเพื่อขอปิด/ยุติโครงการ ', count: 'N' },
            { name: 'ฝ่ายบัญชีและการเงินตรวจสอบเอกสารประกาอบการปิด/ยุติโครงการ', count: 'N' },
            { name: 'ปิดโครงการและจัดเก็บเอกสาร', count: 'N' },
          ],
        },
      ],
    },
    {
      header: 'อื่นๆ (จำนวนโครงการ)',
      bgColor: '#a7f2b1',
      key: 'OTH',
      datas: [
        {
          key: 'OTH1',
          name: 'โครงการล่าช้า',
          percent: '1.64%',
          count: 'N',
          warning: true,
          countColor: '#ffc993',
          icon: 'history',
          iconColor: '#f9cdd1',
          details: [
            { name: 'ล่าช้าเกิน 3 เดือน - 1 ปี', count: 'N', warning: true },
            { name: 'ล่าช้าเกิน 1 ปีขึ้นไป', count: 'N', warning: true },
          ],
        },
        {
          key: 'OTH2',
          name: 'เบิกค่าทบทวน',
          percent: '1.64%',
          count: 'N',
          countColor: '#ffc489',
          icon: 'money',
          iconColor: '#f9cdd1',
          details: [
            { name: 'รอเบิก', count: 'N' },
            { name: 'เสนออนุมัติเบิก', count: 'N' },
            { name: 'อนุมัติเบิก', count: 'N' },
          ],
        },
      ],
    },
  ],
}
